export const cookieName = {
  ACCESS_TOKEN: 'accessToken',
  THEME: 'theme',
};
